import Context from './Context.js';

export default class MyAccount extends Context {
  constructor(data) {
    super();
    this.data = data;
  }

  static get version() {
    return '1-1-0';
  }

  static get key() {
    return 'my_account_context'
  }
}